import(/* webpackMode: "eager" */ "/local/p4clients/pkgbuild-const/workspace/src/AWSMarketingHorizonWebsite/src/app/global-error.tsx");
